import styled from 'styled-components'

const StyledIconContainer = styled.span`
  display: inline-block;
  height: ${props => props.size};
  width: ${props => props.size};
  position: relative;
`

export default StyledIconContainer
